<template>
  <lego-modal
    class="AddMetricPopup"
    ref="modal"
    :title="$t('label.addMetric')"
    :size="600"
    @closed="pageOnCLosed"
  >
    <div class="metricNameContainer">
      <div class="inputBox">
        <div class="metricNameTitle">
          <c-label required weight="bold">
            {{ $util.capitalize($t('label.metricName')) }}
          </c-label>
        </div>
        <lego-text-field
          ref="metricName"
          v-model="metricName"
          :mutateInput="hanldeMetricName"
          width="440"
          inputClass="metricInput"
          class="metricInput"
          counter="87"
          showCounter
          :guide="$t('hint.guideMetric')"
          :rules="inputRules.metricName"
        />
        <div class="metricfilter">metricfilter.</div>
      </div>
      <div class="inputBox">
        <div class="metricNameTitle">
          <c-label weight="bold">
            {{ $util.capitalize($t('label.description')) }}
          </c-label>
        </div>
        <lego-text-field
          ref="metricDescription"
          v-model="metricDescription"
          width="440"
          inputClass="metricInput"
          class="metricInput"
          :counter="1000"
          showCounter
          :rows="6"
          textarea
          :rules="inputRules.metricDescription"
          :guide="$t('label.nameGuide')"
        />
      </div>
    </div>

    <!--    하단버튼-->
    <template #action>
      <lego-button medium @click="pageOnCLosed">{{ $t('button.cancel') }}</lego-button>
      <lego-button medium main @click="saveMetric" :disabled="isDisabledConfirm">{{
        $t('button.save')
      }}</lego-button>
    </template>
  </lego-modal>
</template>
<script>
import validationMixin from '@/mixins/validation.mixin.js';

export default {
  mixins: [validationMixin],
  emits: ['close', 'saveMetric'],
  props: ['params'],
  data() {
    return {
      metricName: '',
      metricDescription: '',
      inputRules: {
        metricName: [
          (v) => !!v.length || this.$t('message.requiredInput'),
          (v) => !this.$util.requireInputMetricName(v) || this.$t('message.errorValidateInput')
        ],
        metricDescription: [
          (v) => !this.$util.requireInputCommon(v) || this.$t('message.errorValidateInput')
        ]
      },
      firstDotIndex: 0
    };
  },
  computed: {
    isDisabledConfirm() {
      if (this.metricName.trim().length === 0) return true;
      if (this.$util.requireInputMetricName(this.metricName)) return true;
      if (this.$util.requireInputCommon(this.metricDescription)) return true;
      return false;
    }
  },
  mounted() {
    this.$refs['modal'].open();
  },
  methods: {
    /*************
     * page
     *************/
    pageOnCLosed() {
      // console.log('this = ', this);
      this.$emit('close');
    },

    // 저장
    saveMetric() {
      if (!this.$util.validate([this.$refs.metricName])) return;
      this.$emit('saveMetric', `metricfilter.${this.metricName}`, this.metricDescription);
    },

    hanldeMetricName(value) {
      const { val, beforeDotIndex } = this.$util.validatorInputMetric(value, this.firstDotIndex);
      this.firstDotIndex = beforeDotIndex;
      return val;
    }
  }
};
</script>
<style>
.metricNameContainer .lego-text-field__input {
  padding-left: 88px !important;
}
</style>
<style lang="scss" scoped>
.metricNameContainer {
  display: flex;
  flex-direction: column;
  width: calc(100% + 20px);
  gap: 20px;
  .metricNameTitle {
    font-family: $lego__font-family;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: var(--dark);
    margin-top: 7px;
    width: 100px;
    position: relative;
    .required {
      position: absolute;
      right: -2px;
    }
  }
  .metricInput {
    flex: 1;
  }
  .required {
    font-family: $lego__font-family;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #f00;
  }

  .inputBox {
    display: flex;
    gap: 16px;
    &:first-child {
      position: relative;
      padding-bottom: 20px;
      :deep(.lego-text-field__message.lego-text-field__message--light) {
        position: absolute;
      }
    }
    .metricfilter {
      position: absolute;
      left: 125px;
      top: 6px;
    }
  }

  .subtext {
    font-family: $lego__font-family;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.42;
    letter-spacing: normal;
    text-align: left;
    color: var(--color-ui-06);
  }
}
.AddMetricPopup {
  :deep(.lego-modal__body) {
    padding: 24px 32px;
    .simplebar-content {
      width: 100%;
    }
  }
  :deep(.lego-modal__container) {
    .lego-modal__head {
      margin: 24px 32px 0 32px;
      padding: 0 0 16px 0;
      min-height: 32px;
      font-size: 22px;
      line-height: 32px;
    }
    .lego-modal__close.lego-icon {
      top: 30px;
      font-size: 22px;
    }
  }
}
</style>
